import React, { useEffect, useState } from "react";
import {
  collection, getDocs, addDoc, updateDoc, deleteDoc, doc, getDoc, setDoc
} from "firebase/firestore";
import { db } from "./firebase";
import ReactSelect from "react-select";
import CountryFlag from "react-country-flag";

// Lista wszystkich krajów ISO
const COUNTRY_LIST = [
  { code: "CN", name: "Chiny" },
  { code: "UA", name: "Ukraina" },
  { code: "PL", name: "Polska" },
    
  // --- EUROPA ---
  { code: "AL", name: "Albania" },
  { code: "BE", name: "Belgia" },
  { code: "BG", name: "Bułgaria" },
  { code: "HR", name: "Chorwacja" },
  { code: "CY", name: "Cypr" },
  { code: "DK", name: "Dania" },
  { code: "EE", name: "Estonia" },
  { code: "FI", name: "Finlandia" },
  { code: "FR", name: "Francja" },
  { code: "DE", name: "Niemcy" },
  { code: "GR", name: "Grecja" },
  { code: "IS", name: "Islandia" },
  { code: "IE", name: "Irlandia" },
  { code: "IT", name: "Włochy" },
  { code: "LV", name: "Łotwa" },
  { code: "LT", name: "Litwa" },
  { code: "LU", name: "Luksemburg" }, // Porty rzeczne połączone z portami morskimi
  { code: "MT", name: "Malta" },
  { code: "MC", name: "Monako" },
  { code: "ME", name: "Czarnogóra" },
  { code: "NL", name: "Holandia" },
  { code: "NO", name: "Norwegia" },
  { code: "PT", name: "Portugalia" },
  { code: "RO", name: "Rumunia" },
  { code: "RU", name: "Rosja" }, // Część europejska
  { code: "SI", name: "Słowenia" },
  { code: "ES", name: "Hiszpania" },
  { code: "SE", name: "Szwecja" },
  { code: "TR", name: "Turcja" }, // Częściowo Europa, częściowo Azja
  { code: "GB", name: "Wielka Brytania" },

  // --- AZJA ---
  { code: "AE", name: "Zjednoczone Emiraty Arabskie" },
  { code: "BD", name: "Bangladesz" },
  { code: "BN", name: "Brunei" },
  { code: "KH", name: "Kambodża" },
  { code: "TL", name: "Timor Wschodni" },
  { code: "IN", name: "Indie" },
  { code: "ID", name: "Indonezja" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Irak" },
  { code: "IL", name: "Izrael" },
  { code: "JP", name: "Japonia" },
  { code: "JO", name: "Jordania" },
  { code: "KW", name: "Kuwejt" },
  { code: "LB", name: "Liban" },
  { code: "MY", name: "Malezja" },
  { code: "MV", name: "Malediwy" },
  { code: "MM", name: "Mjanma (Birma)" },
  { code: "KP", name: "Korea Północna" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PH", name: "Filipiny" },
  { code: "QA", name: "Katar" },
  { code: "SA", name: "Arabia Saudyjska" },
  { code: "SG", name: "Singapur" },
  { code: "KR", name: "Korea Południowa" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SY", name: "Syria" },
  { code: "TW", name: "Tajwan" },
  { code: "TH", name: "Tajlandia" },
  { code: "VN", name: "Wietnam" },
  { code: "YE", name: "Jemen" },
  { code: "HK", name: "Hongkong" },

  // --- AUSTRALIA (Kontynent/Kraj) ---
  { code: "AU", name: "Australia" },

  // --- AMERYKA PÓŁNOCNA I ŚRODKOWA + KARAIBY ---
  { code: "AG", name: "Antigua i Barbuda" },
  { code: "BS", name: "Bahamy" },
  { code: "BB", name: "Barbados" },
  { code: "BZ", name: "Belize" },
  { code: "CA", name: "Kanada" },
  { code: "CR", name: "Kostaryka" },
  { code: "CU", name: "Kuba" },
  { code: "DM", name: "Dominika" },
  { code: "DO", name: "Dominikana" },
  { code: "SV", name: "Salwador" },
  { code: "GD", name: "Grenada" },
  { code: "GT", name: "Gwatemala" },
  { code: "HT", name: "Haiti" },
  { code: "HN", name: "Honduras" },
  { code: "JM", name: "Jamajka" },
  { code: "MX", name: "Meksyk" },
  { code: "NI", name: "Nikaragua" },
  { code: "PA", name: "Panama" },
  { code: "KN", name: "Saint Kitts i Nevis" },
  { code: "LC", name: "Saint Lucia" },
  { code: "VC", name: "Saint Vincent i Grenadyny" },
  { code: "TT", name: "Trynidad i Tobago" },
  { code: "US", name: "Stany Zjednoczone" },

  // --- AMERYKA POŁUDNIOWA ---
  { code: "AR", name: "Argentyna" },
  { code: "BR", name: "Brazylia" },
  { code: "CL", name: "Chile" },
  { code: "CO", name: "Kolumbia" },
  { code: "EC", name: "Ekwador" },
  { code: "GF", name: "Gujana Francuska" }, // Terytorium zamorskie Francji
  { code: "GY", name: "Gujana" },
  { code: "PE", name: "Peru" },
  { code: "SR", name: "Surinam" },
  { code: "UY", name: "Urugwaj" },
  { code: "VE", name: "Wenezuela" },

    // Dodaj resztę wg potrzeb...
];

const TRANSPORT_TYPES = ["FCL", "LCL"];
const CONTAINER_TYPES = ["20ft", "40ft"];

function getCountryOption(code) {
  if (!code) return null;
  const c = COUNTRY_LIST.find(c => c.code === code);
  return c ? {
    value: code,
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <CountryFlag countryCode={code} svg style={{ width: 20, height: 20 }} />
        <span style={{ fontWeight: 600 }}>{code}</span>
        <span style={{ color: "#888" }}>{c.name}</span>
      </span>
    ),
  } : { value: code, label: code };
}

const countrySelectOptions = COUNTRY_LIST.map(c => ({
  value: c.code,
  label: (
    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <CountryFlag countryCode={c.code} svg style={{ width: 20, height: 20 }} />
      <span style={{ fontWeight: 600 }}>{c.code}</span>
      <span style={{ color: "#888" }}>{c.name}</span>
    </span>
  ),
}));

export default function AdminPricing() {
  const [entries, setEntries] = useState([]);
  const [filter, setFilter] = useState({ countryCode: "", port: "", transportType: "", containerType: "", active: "", sort: "dateFrom" });
  const [form, setForm] = useState(getInitialForm());
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState("");
  const [t1, setT1] = useState("");
  const [t1Loading, setT1Loading] = useState(false);
  const [t1Edit, setT1Edit] = useState("");
  const [copyMode, setCopyMode] = useState(false);

  function getInitialForm() {
    return {
      countryCode: "",
      port: "",
      transportType: "FCL",
      containerType: "20ft",
      dateFrom: "",
      dateTo: "",
      price: "",
      thc: "",
      lclPricePerKg: "",
      lclPricePerM3: "",
      lclMinPrice: "",
      lclAdminFee: "",
      comment: "",
      active: true,
    };
  }

  // -- T1 SETTINGS --
  useEffect(() => {
    loadT1();
    async function loadT1() {
      setT1Loading(true);
      try {
        const t1Doc = await getDoc(doc(db, "t1Settings", "currentT1"));
        if (t1Doc.exists()) {
          setT1(t1Doc.data().value || "");
          setT1Edit(t1Doc.data().value?.toString() || "");
        } else {
          setT1("");
          setT1Edit("");
        }
      } catch { setT1(""); }
      setT1Loading(false);
    }
  }, []);

  async function handleT1Save() {
    const v = Number(t1Edit);
    if (isNaN(v) || v < 0) return alert("Wpisz poprawną wartość T1 (liczba).");
    await setDoc(doc(db, "t1Settings", "currentT1"), { value: v });
    setT1(v);
  }

  // -- DANE Z BAZY --
  useEffect(() => {
    fetchEntries();
    async function fetchEntries() {
      const snap = await getDocs(collection(db, "seaPricing"));
      let arr = [];
      snap.forEach(doc => arr.push({ id: doc.id, ...doc.data() }));
      setEntries(arr);
    }
  }, []);

  // -- FILTRY --
  function getFilteredEntries() {
    let arr = entries.slice();
    if (filter.countryCode) arr = arr.filter(e => e.countryCode === filter.countryCode);
    if (filter.port) arr = arr.filter(e => e.port === filter.port);
    if (filter.transportType) arr = arr.filter(e => e.transportType === filter.transportType);
    if (filter.containerType && filter.transportType === "FCL") arr = arr.filter(e => e.containerType === filter.containerType);
    if (filter.active === "1") arr = arr.filter(e => e.active);
    if (filter.active === "0") arr = arr.filter(e => !e.active);
    arr.sort((a, b) => (a[filter.sort] || "").localeCompare(b[filter.sort] || ""));
    return arr;
  }

  // Lista portów do filtrowania
  const allPorts = Array.from(new Set(entries.map(e => e.port))).sort();

  // Lista krajów do filtrowania (dynamiczna z entries, dla selecta w filtrze)
  const allCountries = Array.from(new Set(entries.map(e => e.countryCode))).filter(Boolean);

  // DODAWANIE/EDYCJA
  const showFCL = form.transportType === "FCL";
  const showLCL = form.transportType === "LCL";

  const handleSave = async (e) => {
    e.preventDefault();
    setError("");
    // Walidacja
    if (!form.port || !form.transportType || !form.dateFrom || !form.dateTo || !form.countryCode) {
      setError("Uzupełnij wszystkie wymagane pola (w tym kraj).");
      return;
    }
    if (showFCL && (!form.containerType || !form.price || form.thc === "")) {
      setError("Uzupełnij wszystkie pola FCL.");
      return;
    }
    if (showLCL && (!form.lclPricePerKg || !form.lclPricePerM3 || !form.lclMinPrice || form.lclAdminFee === "")) {
      setError("Uzupełnij wszystkie pola LCL.");
      return;
    }
    // Sprawdzenie nakładania się okresów
    const overlapping = entries.some(e =>
      e.id !== editId &&
      e.port === form.port &&
      e.transportType === form.transportType &&
      (showFCL ? e.containerType === form.containerType : true) &&
      e.active &&
      !(form.dateTo < e.dateFrom || form.dateFrom > e.dateTo)
    );
    if (overlapping) {
      setError("W tej kombinacji port/typ/kontener i zakresie dat już istnieje aktywny wpis.");
      return;
    }
    // Dane do bazy
    let data = {
      port: form.port,
      countryCode: form.countryCode,
      transportType: form.transportType,
      dateFrom: form.dateFrom,
      dateTo: form.dateTo,
      active: !!form.active,
      comment: form.comment || "",
    };
    if (showFCL) {
      data.containerType = form.containerType;
      data.price = Number(form.price);
      data.thc = Number(form.thc);
    }
    if (showLCL) {
      data.lclPricePerKg = Number(form.lclPricePerKg);
      data.lclPricePerM3 = Number(form.lclPricePerM3);
      data.lclMinPrice = Number(form.lclMinPrice);
      data.lclAdminFee = Number(form.lclAdminFee);
    }

    if (editId && !copyMode) {
      await updateDoc(doc(db, "seaPricing", editId), data);
    } else {
      await addDoc(collection(db, "seaPricing"), data);
    }
    // Odśwież dane
    const snap = await getDocs(collection(db, "seaPricing"));
    let arr = [];
    snap.forEach(doc => arr.push({ id: doc.id, ...doc.data() }));
    setEntries(arr);
    setForm(getInitialForm());
    setEditId(null);
    setCopyMode(false);
    setError("");
  };

  // Usuwanie wpisu
  const handleDelete = async (id) => {
    if (!window.confirm("Usunąć ten wpis?")) return;
    await deleteDoc(doc(db, "seaPricing", id));
    setEntries(entries.filter(e => e.id !== id));
    if (editId === id) {
      setEditId(null);
      setForm(getInitialForm());
    }
  };

  // Edycja
  const handleEdit = (entry) => {
    setEditId(entry.id);
    setCopyMode(false);
    setForm({ ...getInitialForm(), ...entry });
  };

  // Kopiowanie
  const handleCopy = (entry) => {
    setCopyMode(true);
    setEditId(null);
    setForm({ ...getInitialForm(), ...entry });
  };

  // Aktywność
  const toggleActive = async (id, val) => {
    await updateDoc(doc(db, "seaPricing", id), { active: val });
    setEntries(entries.map(e => e.id === id ? { ...e, active: val } : e));
  };

  // Reset
  const handleCancel = () => {
    setEditId(null);
    setForm(getInitialForm());
    setCopyMode(false);
    setError("");
  };

  // --- RENDER ---
  return (
    <div className="max-w-6xl mx-auto my-8 bg-white p-6 rounded-lg shadow space-y-8">
      <div className="flex flex-wrap justify-between items-center mb-4 gap-4">
        <h1 className="text-2xl font-bold text-blue-700">Cennik morski – FCL / LCL</h1>
        <div className="flex items-center gap-2">
          <span className="font-semibold text-blue-700">T1</span>
          <input
            type="number"
            className="border px-2 py-1 rounded w-16"
            style={{ width: 60 }}
            value={t1Edit}
            onChange={e => setT1Edit(e.target.value.replace(/\D/, ""))}
            disabled={t1Loading}
          />
          <button
            className="bg-blue-700 text-white px-3 py-1 rounded shadow hover:bg-blue-800 transition"
            onClick={handleT1Save}
            disabled={t1Loading}
            style={{ minWidth: 70 }}
          >Zapisz</button>
          <span className="ml-2 text-xs text-gray-500">Aktualnie: <b>{t1}</b> USD</span>
        </div>
      </div>

      {/* FILTRY */}
      <div className="flex flex-wrap gap-4 mb-6 items-end">
        <div>
          <label className="block text-xs mb-1">Kraj</label>
          <ReactSelect
            className="min-w-[130px] w-[170px]"
            isClearable
            placeholder="Wszystkie"
            options={COUNTRY_LIST.map(c => ({
              value: c.code,
              label: (
                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <CountryFlag countryCode={c.code} svg style={{ width: 18, height: 18 }} />
                  <span style={{ fontWeight: 600 }}>{c.code}</span>
                  <span style={{ color: "#888" }}>{c.name}</span>
                </span>
              ),
            }))}
            value={filter.countryCode ? getCountryOption(filter.countryCode) : null}
            onChange={val => setFilter(f => ({ ...f, countryCode: val?.value || "" }))}
          />
        </div>
        <div>
          <label className="block text-xs mb-1">Port</label>
          <select className="border px-2 py-1 rounded min-w-[100px]" value={filter.port} onChange={e => setFilter(f => ({ ...f, port: e.target.value }))}>
            <option value="">(wszystkie)</option>
            {allPorts.map(p => <option key={p}>{p}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs mb-1">Transport</label>
          <select className="border px-2 py-1 rounded" value={filter.transportType} onChange={e => setFilter(f => ({ ...f, transportType: e.target.value, containerType: "" }))}>
            <option value="">(wszystko)</option>
            {TRANSPORT_TYPES.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
        {filter.transportType === "FCL" && (
          <div>
            <label className="block text-xs mb-1">Kontener</label>
            <select className="border px-2 py-1 rounded" value={filter.containerType} onChange={e => setFilter(f => ({ ...f, containerType: e.target.value }))}>
              <option value="">(wszystkie)</option>
              {CONTAINER_TYPES.map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
        )}
        <div>
          <label className="block text-xs mb-1">Aktywność</label>
          <select className="border px-2 py-1 rounded" value={filter.active} onChange={e => setFilter(f => ({ ...f, active: e.target.value }))}>
            <option value="">(wszystko)</option>
            <option value="1">Tylko aktywne</option>
            <option value="0">Tylko nieaktywne</option>
          </select>
        </div>
        <div>
          <label className="block text-xs mb-1">Sortuj po</label>
          <select className="border px-2 py-1 rounded" value={filter.sort} onChange={e => setFilter(f => ({ ...f, sort: e.target.value }))}>
            <option value="dateFrom">Data od</option>
            <option value="dateTo">Data do</option>
            <option value="port">Port</option>
          </select>
        </div>
      </div>

      {/* FORMULARZ */}
      <form className="bg-blue-50 rounded-lg p-4 space-y-2" onSubmit={handleSave}>
        <div className="flex flex-wrap gap-4 items-end">
          <div>
            <label className="block text-xs mb-1">Kraj*</label>
            <ReactSelect
              className="min-w-[130px] w-[170px]"
              placeholder="Wybierz kraj"
              options={countrySelectOptions}
              value={getCountryOption(form.countryCode)}
              onChange={val => setForm(f => ({ ...f, countryCode: val?.value || "" }))}
              required
            />
          </div>
          <div>
            <label className="block text-xs mb-1">Port*</label>
            <input className="border px-2 py-1 rounded w-[110px]" value={form.port} onChange={e => setForm(f => ({ ...f, port: e.target.value }))} required />
          </div>
          <div>
            <label className="block text-xs mb-1">Transport*</label>
            <select className="border px-2 py-1 rounded" value={form.transportType} onChange={e =>
              setForm(f => ({
                ...getInitialForm(),
                ...f,
                transportType: e.target.value,
                containerType: e.target.value === "FCL" ? (f.containerType || "20ft") : "",
              }))
            }>
              {TRANSPORT_TYPES.map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
          {showFCL && (
            <>
              <div>
                <label className="block text-xs mb-1">Kontener*</label>
                <select className="border px-2 py-1 rounded" value={form.containerType} onChange={e => setForm(f => ({ ...f, containerType: e.target.value }))}>
                  {CONTAINER_TYPES.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-xs mb-1">Data od*</label>
                <input type="date" className="border px-2 py-1 rounded" value={form.dateFrom} onChange={e => setForm(f => ({ ...f, dateFrom: e.target.value }))} />
              </div>
              <div>
                <label className="block text-xs mb-1">Data do*</label>
                <input type="date" className="border px-2 py-1 rounded" value={form.dateTo} onChange={e => setForm(f => ({ ...f, dateTo: e.target.value }))} />
              </div>
              <div>
                <label className="block text-xs mb-1">Fracht USD*</label>
                <input type="number" className="border px-2 py-1 rounded" value={form.price} onChange={e => setForm(f => ({ ...f, price: e.target.value }))} />
              </div>
              <div>
                <label className="block text-xs mb-1">THC USD*</label>
                <input type="number" className="border px-2 py-1 rounded" value={form.thc} onChange={e => setForm(f => ({ ...f, thc: e.target.value }))} />
              </div>
            </>
          )}
          {showLCL && (
            <>
              <div>
                <label className="block text-xs mb-1">Data od*</label>
                <input type="date" className="border px-2 py-1 rounded" value={form.dateFrom} onChange={e => setForm(f => ({ ...f, dateFrom: e.target.value }))} />
              </div>
              <div>
                <label className="block text-xs mb-1">Data do*</label>
                <input type="date" className="border px-2 py-1 rounded" value={form.dateTo} onChange={e => setForm(f => ({ ...f, dateTo: e.target.value }))} />
              </div>
              <div>
                <label className="block text-xs mb-1">Cena za kg*</label>
                <input type="number" className="border px-2 py-1 rounded" value={form.lclPricePerKg} onChange={e => setForm(f => ({ ...f, lclPricePerKg: e.target.value }))} />
              </div>
              <div>
                <label className="block text-xs mb-1">Cena za m³*</label>
                <input type="number" className="border px-2 py-1 rounded" value={form.lclPricePerM3} onChange={e => setForm(f => ({ ...f, lclPricePerM3: e.target.value }))} />
              </div>
              <div>
                <label className="block text-xs mb-1">Minimalna cena*</label>
                <input type="number" className="border px-2 py-1 rounded" value={form.lclMinPrice} onChange={e => setForm(f => ({ ...f, lclMinPrice: e.target.value }))} />
              </div>
              <div>
                <label className="block text-xs mb-1">Opłata adm.*</label>
                <input type="number" className="border px-2 py-1 rounded" value={form.lclAdminFee} onChange={e => setForm(f => ({ ...f, lclAdminFee: e.target.value }))} />
              </div>
            </>
          )}
          <div className="flex flex-col">
            <label className="block text-xs mb-1">Aktywny</label>
            <input type="checkbox" checked={!!form.active} onChange={e => setForm(f => ({ ...f, active: e.target.checked }))} />
          </div>
          <div className="flex flex-col flex-1 min-w-[200px]">
            <label className="block text-xs mb-1">Komentarz</label>
            <input className="border px-2 py-1 rounded" value={form.comment || ""} onChange={e => setForm(f => ({ ...f, comment: e.target.value }))} />
          </div>
          <div className="flex flex-col min-w-[110px] gap-2">
            <button className="bg-blue-700 text-white px-3 py-1 rounded shadow hover:bg-blue-800 transition border border-blue-500" type="submit">
              {editId && !copyMode ? "Zapisz zmiany" : "Dodaj"}
            </button>
            {(editId || copyMode) && (
              <button className="bg-gray-400 text-white px-3 py-1 rounded" type="button" onClick={handleCancel}>
                Anuluj
              </button>
            )}
          </div>
        </div>
        {error && <div className="text-red-600 mt-2 font-semibold">{error}</div>}
      </form>

      {/* TABELA */}
      <div className="overflow-x-auto">
        <table className="w-full border text-xs">
          <thead>
            <tr className="bg-blue-100 text-blue-800">
              <th className="border px-1 py-1 min-w-[130px]">Kraj</th>
              <th className="border px-1 py-1">Port</th>
              <th className="border px-1 py-1">Typ</th>
              <th className="border px-1 py-1">Kontener</th>
              <th className="border px-1 py-1">Data od</th>
              <th className="border px-1 py-1">Data do</th>
              <th className="border px-1 py-1">Cena</th>
              <th className="border px-1 py-1">THC</th>
              <th className="border px-1 py-1">Cena/kg</th>
              <th className="border px-1 py-1">Cena/m³</th>
              <th className="border px-1 py-1">Min</th>
              <th className="border px-1 py-1">Admin</th>
              <th className="border px-1 py-1">Aktywny</th>
              <th className="border px-1 py-1">Komentarz</th>
              <th className="border px-1 py-1"></th>
            </tr>
          </thead>
          <tbody>
              {getFilteredEntries().map((e, idx) => {
                // Czy przeterminowane?
                const isExpired =
                  e.dateTo &&
                  new Date(e.dateTo) < new Date() &&
                  !!e.active; // aktywny, ale po terminie

                // Czy nieaktywny (ręcznie wyłączony w bazie)
                const isInactive = !e.active;

                // Tło co druga linijka (białe lub niebieskie)
                const baseRowClass =
                  idx % 2 === 0 ? "" : "bg-blue-50";

                // Warianty kolorowania:
                let rowClass = baseRowClass;
                let rowStyle = {};
                if (isInactive) {
                  rowClass = "bg-gray-100 text-gray-400";
                } else if (isExpired) {
                  rowStyle = { background: "#f0a337" };
                }

                return (
                  <tr key={e.id} className={rowClass} style={rowStyle}>
                    <td className="border px-1 py-1">
                      <span className="flex items-center gap-1">
                        <CountryFlag countryCode={e.countryCode} svg style={{ width: 18, height: 18 }} />
                        <span className="font-semibold">{e.countryCode}</span>
                        <span className="text-xs text-gray-500 ml-1">{COUNTRY_LIST.find(c => c.code === e.countryCode)?.name || ""}</span>
                      </span>
                    </td>
                    <td className="border px-1 py-1">{e.port}</td>
                    <td className="border px-1 py-1">{e.transportType}</td>
                    <td className="border px-1 py-1">{e.containerType || "-"}</td>
                    <td className="border px-1 py-1">{e.dateFrom}</td>
                    <td className="border px-1 py-1">{e.dateTo}</td>
                    <td className="border px-1 py-1">{e.price !== undefined ? e.price : "-"}</td>
                    <td className="border px-1 py-1">{e.thc !== undefined ? e.thc : "-"}</td>
                    <td className="border px-1 py-1">{e.lclPricePerKg !== undefined ? e.lclPricePerKg : "-"}</td>
                    <td className="border px-1 py-1">{e.lclPricePerM3 !== undefined ? e.lclPricePerM3 : "-"}</td>
                    <td className="border px-1 py-1">{e.lclMinPrice !== undefined ? e.lclMinPrice : "-"}</td>
                    <td className="border px-1 py-1">{e.lclAdminFee !== undefined ? e.lclAdminFee : "-"}</td>
                    <td className="border px-1 py-1 text-center">
                      <input type="checkbox" checked={!!e.active} onChange={ev => toggleActive(e.id, ev.target.checked)} />
                    </td>
                    <td className="border px-1 py-1 max-w-[140px] truncate" title={e.comment}>{e.comment}</td>
                    <td className="border px-1 py-1">
                      <button className="text-blue-700 underline mr-2" onClick={() => handleEdit(e)}>Edytuj</button>
                      <button className="text-green-700 underline mr-2" onClick={() => handleCopy(e)}>Kopiuj</button>
                      <button className="text-red-500 underline" onClick={() => handleDelete(e.id)}>Usuń</button>
                    </td>
                  </tr>
                );
              })}
              {getFilteredEntries().length === 0 && (
                <tr>
                  <td colSpan={15} className="p-4 text-center text-gray-400">Brak stawek.</td>
                </tr>
              )}
            </tbody>
        </table>
      </div>
    </div>
  );
}
